// extracted by mini-css-extract-plugin
export default {"dashboard":"layouts_dashboard__rw67S","section":"layouts_section__8Fal0","form":"layouts_form__TRBA7"};